import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PageService} from '../../../page/services/page.service';

@Component({
  selector: 'app-multiple-search-expediente-modal',
  templateUrl: './multiple-search-expediente-modal.component.html',
  styleUrls: ['./multiple-search-expediente-modal.component.css']
})
export class MultipleSearchExpedienteModalComponent implements OnInit {

  numPedido = '' ;
  pedidos: number [] = [];
  constructor(public dialogRef: MatDialogRef<MultipleSearchExpedienteModalComponent>,
              private pageService: PageService,  @Inject(MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit(): void {
  }

  addToPedidosList(): void {
    console.log(this.numPedido);
    this.pedidos.push(+this.numPedido);
    this.numPedido = '';
  }

  removeFromList(i: number) {
    this.pedidos.splice(i, 1);
  }

}
